/**
 * Do not edit directly
 */

export default "PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJhIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTEzLjQ5LDkuNUgzLjVWNS4yMWwxLjcxLTEuNzFoNy4yOHYyaC0xLjk5bDIuNDksMi41LDIuNTEtMi41aC0yLjAxVjIuNUg1LjIxTDMsLjI5LC4yOSwzbDIuMjEsMi4yMVYxNWgxdi00LjVIMTIuNDl2MmgtMS45OWwyLjQ5LDIuNSwyLjUxLTIuNWgtMi4wMXYtM1pNMywxLjcxbDEuMjksMS4yOS0xLjI5LDEuMjktMS4yOS0xLjI5LDEuMjktMS4yOVoiLz48L3N2Zz4=";